var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#8EB4C3",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7413 60.3223L46.5772 49.8438C45.6604 49.1313 44.9896 48.1497 44.6589 47.0367C44.3282 45.9236 44.3543 44.735 44.7334 43.6375C45.1125 42.54 45.8256 41.5888 46.7728 40.9171C47.72 40.2455 48.8536 39.8872 50.0147 39.8926V28.2617H35.835C34.3771 28.2625 32.9791 28.842 31.9482 29.8729C30.9173 30.9038 30.3377 32.3018 30.337 33.7598V60.6934C30.3341 61.2006 30.4477 61.7018 30.669 62.1582C31.8604 64.5605 36.5479 72.2852 49.9952 78.2227V60.7519C48.2348 60.7601 46.4769 60.6164 44.7413 60.3223ZM64.1456 28.2227H49.9952V39.8535C51.1506 39.8463 52.2795 40.1997 53.2246 40.8644C54.1697 41.5292 54.8839 42.4722 55.2676 43.5621C55.6513 44.652 55.6855 45.8345 55.3653 46.9447C55.0452 48.0549 54.3866 49.0376 53.4815 49.7559L55.3174 60.2832C53.5613 60.5873 51.7823 60.7408 50.0001 60.7422V78.1836C63.4278 72.2754 68.1348 64.5215 69.3262 62.1191C69.5475 61.6627 69.6611 61.1615 69.6583 60.6543V33.7402C69.6635 33.0155 69.5246 32.2969 69.2496 31.6263C68.9747 30.9557 68.5692 30.3465 68.0567 29.834C67.0172 28.801 65.611 28.2216 64.1456 28.2227Z",
    fill: "#BFE5F4",
    fillOpacity: 0.41
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.6d02034ac5e382968d44290f092ca042.svg";
export { ForwardRef as ReactComponent };